import { useCallback, useEffect, useState } from 'react';

const useIsTabActive = () => {
  const [isTabVisible, setIsTabVisible] = useState(document.visibilityState === 'visible');

  const handleVisibilityChange = () => {
    setIsTabVisible(isTabVisible => !isTabVisible);
  };

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return isTabVisible;
};

export default useIsTabActive;
